import { LinuiTheme } from './LinuiTheme';
import { colorPalette as dark } from './darkMode/colorPalette';
import { colorPalette as light } from './lightMode/colorPalette';
export { LinuiTheme } from './LinuiTheme';

/**
 * @deprecated `<GitstreamTheme>` is deprecated, use `<LinuiTheme>` instead.
 */
export const GitstreamTheme = LinuiTheme;

export const colorPalettes = { dark, light };
